import pick from 'lodash/pick';
import { createOrderPayload } from '@buddy-technology/ion-helpers';

const createSelectivePayload = (data, selectedFields) => {
	const rawSelectedData = pick(data, selectedFields);
	return createOrderPayload(rawSelectedData);
};

export default createSelectivePayload;
